import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class DinnerItem extends Phaser.GameObjects.Sprite {
    id: number;
    served: boolean;

    constructor(scene: Phaser.Scene, ob: TiledGameObject, type: "drink" | "entree" | "dessert", id: number) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "trayfood" + id);

        this.type = type;
        this.id = id;
        this.served = false;

        this.setDepth(3);

        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this);
        this.scene.add.existing(this);
    }

    putOnPlate(patron: Patron) {
        if (this.type === "drink") {
            this.x = patron.plate.right + 20;
            this.y = patron.plate.centerY;
        }
        else if (this.type === "entree") {
            this.x = patron.plate.centerX - 25;
            this.y = patron.plate.centerY - 5;
        }
        else if (this.type === "dessert") {
            this.x = patron.plate.centerX + 25;
            this.y = patron.plate.centerY;
        }

        this.setDepth(2);
        this.setFrame("platefood" + this.id);
    }
}


export class Patron extends Phaser.GameObjects.Zone {
    id: number;
    entreeId: number;
    drinkId: number;
    dessertId: number;
    bubble: Phaser.GameObjects.Image;
    desiredItem: Phaser.GameObjects.Image;
    served: boolean;

    plate: Phaser.Geom.Rectangle;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
        this.id = ob.properties["id"];
        this.served = false;
        this.drinkId = ob.properties["drinkId"];
        this.entreeId = ob.properties["entreeId"];
        this.dessertId = ob.properties["dessertId"];

        this.scene.add.existing(this);

        this.bubble = this.scene.add.image(this.x, 100, "assets", "bubble");
        this.bubble.setVisible(false);

        this.desiredItem = this.scene.add.image(this.x, this.bubble.y, "assets", "bubblefood" + this.drinkId);
        this.desiredItem.setVisible(false);
        Phaser.Display.Align.In.Center(this.desiredItem, this.bubble);

        this.setRectangleDropZone(this.width, this.height);
    }

}



// WEBPACK FOOTER //
// ./src/games/WaiterMemoryGame/objects/DinnerItem.ts